import './cases-filter.scss'
class StickyDropdowns {
    el
    constructor() {
        this.el = document.querySelector('[data-cases-dropdowns]')
        if(this.el) {
            this.setTop();
        }
    }

    setTop() {
        const header = document.querySelector('[data-header]');
        this.el.style.top = (header.offsetHeight - 1) + 'px';
    }
}

new StickyDropdowns()
